(function () {
  "use strict";

  // Ziel-Endpunkt. Leer = es geht nichts ins Netz, es wird nur der Warenkorb gespiegelt.
  var ZIEL = (window.FL_TELEMETRIE_ZIEL || "").trim();
  var SCHLUESSEL = "fl_tel_v1";
  var KLICK_ZIELE = ".fl-btn, .fl-buy__cart, .fl-buy__opt-btn, .fl-card__quickadd, .fl-qty button, .fl-pot__btn, .fl-cd__checkout, .fl-cd__continue, .fl-cd-item__rm, .fl-cd-card__add, .fl-cp-item__rm, .fl-cp-sum__checkout, .fl-icon-btn, .fl-cmd-row, a[href*='/products/'], a[href*='/collections/']";

  var erlaubt = null;      // null = noch unbekannt
  var gesendet = false;
  var start = Date.now();
  var maxTiefe = 0;
  var klicks = [];
  var leerklicks = 0;
  var wutklicks = 0;
  var letzterKlick = { x: -99, y: -99, t: 0, n: 0 };

  function jetzt() { return Date.now(); }
  function kurz(s, n) { return String(s == null ? "" : s).replace(/\s+/g, " ").trim().slice(0, n || 60); }

  function sitzung() {
    var roh = null;
    try { roh = sessionStorage.getItem(SCHLUESSEL); } catch (e) { }
    if (roh) { try { return JSON.parse(roh); } catch (e) { } }
    var p = new URLSearchParams(location.search);
    var neu = {
      id: (Math.random().toString(36).slice(2) + jetzt().toString(36)),
      beginn: new Date().toISOString(),
      landing: location.pathname,
      referrer: kurz((document.referrer || "").replace(/^https?:\/\//, "").split("/")[0], 80),
      utm_source: kurz(p.get("utm_source"), 40),
      utm_medium: kurz(p.get("utm_medium"), 40),
      utm_campaign: kurz(p.get("utm_campaign"), 60),
      gclid: p.get("gclid") ? "ja" : "nein",
      geraet: window.matchMedia("(max-width: 767px)").matches ? "mobil" : "desktop",
      viewport: window.innerWidth + "x" + window.innerHeight,
      seiten: []
    };
    speichern(neu);
    return neu;
  }

  function speichern(s) {
    try { sessionStorage.setItem(SCHLUESSEL, JSON.stringify(s)); } catch (e) { }
  }

  function seitentyp() {
    var p = location.pathname;
    if (p.indexOf("/products/") === 0 || p.indexOf("/products/") > -1) return "produkt";
    if (p.indexOf("/collections/") > -1) return "kategorie";
    if (p === "/cart") return "warenkorb";
    if (p.indexOf("/blogs/") > -1) return "artikel";
    if (p === "/") return "start";
    if (p.indexOf("/search") > -1) return "suche";
    return "sonstige";
  }

  function tiefeMessen() {
    var doc = document.documentElement;
    var hoehe = Math.max(doc.scrollHeight - window.innerHeight, 1);
    var anteil = Math.round((window.scrollY / hoehe) * 100);
    if (anteil > maxTiefe) maxTiefe = Math.max(0, Math.min(100, anteil));
  }

  // Wird pro Seitenaufruf mehrfach gerufen (visibilitychange, dann pagehide). Der Eintrag
  // darf dabei nur einmal entstehen und danach aktualisiert werden, sonst steht dieselbe
  // Seite mehrfach in der Route und seiten_gesamt zaehlt zu hoch.
  var seiteDrin = false;
  function seiteAbschliessen() {
    var s = sitzung();
    var dauer = Math.round((jetzt() - start) / 1000);
    if (seiteDrin && s.seiten.length) s.seiten.pop();
    seiteDrin = true;
    s.seiten.push({
      pfad: location.pathname,
      typ: seitentyp(),
      sekunden: dauer,
      tiefe: maxTiefe,
      klicks: klicks.slice(0, 25),
      leerklicks: leerklicks,
      wutklicks: wutklicks
    });
    if (s.seiten.length > 30) s.seiten = s.seiten.slice(-30);
    speichern(s);
    return s;
  }

  function nutzlast(s, grund) {
    return {
      v: 1,
      grund: grund,
      sitzung: s.id,
      beginn: s.beginn,
      ende: new Date().toISOString(),
      landing: s.landing,
      referrer: s.referrer,
      utm_source: s.utm_source,
      utm_medium: s.utm_medium,
      utm_campaign: s.utm_campaign,
      gclid: s.gclid,
      geraet: s.geraet,
      viewport: s.viewport,
      seiten_gesamt: s.seiten.length,
      warenkorb_ereignisse: s.warenkorb || 0,
      seiten: s.seiten
    };
  }

  // Bewusst text/plain: application/json ist nicht CORS-safelisted und wuerde einen Preflight ausloesen,
  // den sendBeacon nicht ausfuehren kann. n8n liest den Rohkoerper trotzdem als JSON.
  // Nur bezahlter Traffic. Organisch und direkt wuerden das Execution-Kontingent fuellen,
  // ohne die Frage zu beantworten, warum Ads-Klicks nicht in den Warenkorb fuehren.
  function istAds(s) {
    return s.gclid === "ja" || s.utm_medium === "product_sync" || s.utm_source === "google";
  }

  function senden(grund) {
    if (!ZIEL || erlaubt !== true) return false;
    if (!istAds(sitzung())) return false;
    var s = seiteAbschliessen();
    var daten = JSON.stringify(nutzlast(s, grund));
    var ok = false;
    try {
      if (navigator.sendBeacon) ok = navigator.sendBeacon(ZIEL, new Blob([daten], { type: "text/plain;charset=UTF-8" }));
    } catch (e) { }
    if (!ok) {
      try {
        fetch(ZIEL, { method: "POST", body: daten, keepalive: true, mode: "no-cors" });
        ok = true;
      } catch (e) { }
    }
    if (ok) { gesendet = true; try { sessionStorage.removeItem(SCHLUESSEL); } catch (e) { } }
    return ok;
  }

  // Warenkorb-Spiegelung: schreibt die Route als Warenkorb-Attribut, sobald ein Warenkorb existiert.
  // Dadurch taucht sie bei abgebrochenen Checkouts in der Admin-API auf, auch ohne Endpunkt.
  var spiegelTimer = null;
  function spiegeln() {
    clearTimeout(spiegelTimer);
    spiegelTimer = setTimeout(function () {
      var s = sitzung();
      s.warenkorb = (s.warenkorb || 0) + 1;
      speichern(s);
      var route = s.seiten.concat([{ pfad: location.pathname, typ: seitentyp(), sekunden: Math.round((jetzt() - start) / 1000), tiefe: maxTiefe }])
        .map(function (p) { return p.typ + ":" + p.pfad + "(" + p.sekunden + "s," + p.tiefe + "%)"; })
        .join(" > ").slice(0, 900);
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            "_fl_tel_sitzung": s.id,
            "_fl_tel_geraet": s.geraet,
            "_fl_tel_quelle": s.utm_source || s.referrer || "direkt",
            "_fl_tel_route": route,
            "_fl_tel_seiten": String(s.seiten.length + 1)
          }
        })
      }).catch(function () { });
    }, 800);
  }

  function klickErfassen(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var treffer = t.closest(KLICK_ZIELE);
    var d = jetzt();
    var nah = Math.abs(e.clientX - letzterKlick.x) < 30 && Math.abs(e.clientY - letzterKlick.y) < 30;
    if (nah && d - letzterKlick.t < 1200) {
      letzterKlick.n++;
      if (letzterKlick.n >= 3) wutklicks++;
    } else {
      letzterKlick = { x: e.clientX, y: e.clientY, t: d, n: 1 };
    }
    if (!treffer) { leerklicks++; return; }
    var name = (treffer.tagName || "").toLowerCase() + (treffer.className && typeof treffer.className === "string" ? "." + treffer.className.split(" ")[0] : "");
    klicks.push(kurz(name + "|" + (treffer.innerText || treffer.getAttribute("aria-label") || ""), 70));
    if (treffer.matches(".fl-btn, .fl-buy__cart, .fl-card__quickadd, .fl-cd-card__add, .fl-cp-card__add")) spiegeln();
  }

  var ladeLaeuft = false;
  function pruefeEinwilligung() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === "function") {
        erlaubt = !!cp.analyticsProcessingAllowed();
        return;
      }
      // Die Consent-API liegt nicht von selbst im Fenster, sie muss angefordert werden.
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function" && !ladeLaeuft) {
        ladeLaeuft = true;
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
          ladeLaeuft = false;
          try {
            var c = window.Shopify && window.Shopify.customerPrivacy;
            if (c && typeof c.analyticsProcessingAllowed === "function") erlaubt = !!c.analyticsProcessingAllowed();
          } catch (e) { }
        });
      }
    } catch (e) { }
  }

  function start_() {
    pruefeEinwilligung();
    document.addEventListener("visitorConsentCollected", pruefeEinwilligung);
    window.addEventListener("scroll", tiefeMessen, { passive: true });
    document.addEventListener("click", klickErfassen, true);
    tiefeMessen();

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") senden("versteckt");
    });
    window.addEventListener("pagehide", function () { if (!gesendet) senden("verlassen"); });
    window.addEventListener("beforeunload", function () { if (!gesendet) seiteAbschliessen(); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start_);
  else start_();

  window.flTelemetrie = {
    stand: function () { return sitzung(); },
    ziel: function () { return ZIEL || "(kein Endpunkt gesetzt)"; },
    einwilligung: function () { return erlaubt; }
  };
})();
